import { Button } from "antd";
import { SocketConnector } from "@sdk/@libs/socket-connector";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useThrottle } from "react-use";
import { selectSocketStatus } from "store/modules/app-state/app-state.selectors";
import {
  selectCurrentUserDisabledFromJoiningChats,
  selectCurrentUserId,
} from "store/modules/users/users.selectors";

export const SocketDisconnectedBanner = () => {
  const currentUserId = useSelector(selectCurrentUserId);

  // throttledCurrentUserId to detect if currentUserId is recently changed
  const throttledCurrentUserId = useThrottle(currentUserId, 2000);

  const isCurrentUserDisabledFromJoiningChats = useSelector(
    selectCurrentUserDisabledFromJoiningChats,
  );

  const isSocketConnected = useSelector(selectSocketStatus);

  const [isAppReady, setAppReady] = useState(false);
  const [isReconnecting, setIsReconnecting] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setAppReady(true);
    }, 6000);
    return () => {
      clearTimeout(timer);
    };
  }, []);

  const handleReconnect = () => {
    setIsReconnecting(true);
    try {
      if (SocketConnector.socket) {
        SocketConnector.socket.connect();
      }
    } finally {
      setTimeout(() => {
        setIsReconnecting(false);
      }, 2000);
    }
  };

  const showBanner =
    currentUserId && !isSocketConnected && isAppReady && throttledCurrentUserId;

  return (
    <>
      {showBanner && (
        <div className="bg-amber-600 dark:bg-amber-700 text-white font-medium flex justify-between items-center px-4 py-1.5 text-xs shadow-sm z-50">
          <div className="flex items-center gap-2">
            <i className="ri-wifi-off-line text-sm animate-pulse" />
            <span>
              Connection paused. Real-time chat updates may be delayed.
            </span>
          </div>
          <div className="flex items-center gap-2">
            <Button
              size="small"
              type="primary"
              className="bg-white text-amber-800 hover:bg-gray-100 border-none font-bold text-xs"
              loading={isReconnecting}
              onClick={handleReconnect}
              icon={<i className="ri-refresh-line" />}
            >
              Reconnect
            </Button>
            <Button
              size="small"
              type="text"
              className="text-white hover:text-amber-100 text-xs"
              target="_blank"
              href="https://click-connector.betteruptime.com"
            >
              Status
            </Button>
          </div>
        </div>
      )}
    </>
  );
};
